import { ReactNode } from 'react'
import classnames from 'classnames'
import { CharStatus } from '../../lib/statuses'
import { MAX_WORD_LENGTH, REVEAL_TIME_MS } from '../../constants/settings'
import { getStoredIsHighContrastMode } from '../../lib/localStorage'

type Props = {
  children?: ReactNode
  value: string
  width?: number
  status?: CharStatus
  onClick: (value: string) => void
  isRevealing?: boolean
}

export const Key = ({
  children,
  status,
  width = 40,
  value,
  onClick,
  isRevealing,
}: Props) => {
  const keyDelayMs = REVEAL_TIME_MS * MAX_WORD_LENGTH
  const isHighContrast = getStoredIsHighContrastMode()

  const classes = classnames(
    'flex items-center justify-center rounded-full mx-1 text-xs font-bold cursor-pointer select-none dark:text-white font-mono px-4 py-2 bg-gradient-to-b from-quantum-start to-quantum-end hover:shadow-[0_0_4px_rgba(80,250,255,.6)] transition-shadow',
    {
      'transition ease-in-out': isRevealing,
      'opacity-50': !status,
      'opacity-30': status === 'absent',
      'from-orange-500 to-orange-600': status === 'correct' && isHighContrast,
      'from-cyan-500 to-cyan-600': status === 'present' && isHighContrast,
      'from-green-500 to-green-600': status === 'correct' && !isHighContrast,
      'from-purple-500 to-purple-600': status === 'present' && !isHighContrast,
    }
  )

  const styles = {
    transitionDelay: isRevealing ? `${keyDelayMs}ms` : 'unset',
    width: `${width}px`,
    height: '58px',
  }

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    onClick(value)
    event.currentTarget.blur()
  }

  return (
    <button style={styles} className={classes} onClick={handleClick}>
      {children || value}
    </button>
  )
}
